import { eRecordingFees } from '../../../ui-toolkit/enums/eRecordingFees';

export default function generateRecordingFeeOptions() {
  return Object.entries({
    Assignment: eRecordingFees.assignment,
    CEMA: eRecordingFees.cema,
    'Lien Release': eRecordingFees.lien_release,
    Memorandum: eRecordingFees.memorandum,
    'Mortgage Tax Affidavit': eRecordingFees.mortgage_tax_affidavit,
    'Notice of Settlement': eRecordingFees.notice_of_settlement,
    'Power of Attorney': eRecordingFees.power_of_attorney,
    'Subordination Agreement': eRecordingFees.subordination_agreement,
    'UCC 3': eRecordingFees.ucc_3,
  }).map((entry) => ({ label: entry[0], value: entry[1] }));
}
